<template>
  <div id="home-view">
    <head>
      <meta name="description" content="Welcome to CalMed Hawaii - Your trusted source for medical supplies in Hawaii. Providing quality healthcare products for over 20 years">
    </head>
    <section class="bg-home1 ftco-section mt-lg-5">
      <div class="container-fluid">
        <div class="col-md-6 d-flex pl-lg-5 " >
          <h1 class=" text-uppercase display-4 home-text">
            Your Choice for Better<br> Patient Care<br>
          </h1>
        </div>
      </div>
    </section>
    <section class="ftco-section1 bg-light">
      <div class="container  text-center">
        <h1 class="text-uppercase display-4">supporting mothers </h1>
        <h3 class="sub-heading">physically and emotionally</h3>
        <p class="text-center text-black">
          Bringing a new life into the world is amazing but not everything with that comes easily and no new parent
          should feel alone in the journey. We are here for you and your ohana, we offer support groups, breastfeeding
          classes and Prenatal Lactation Consults. CalMed Hawaii is here to support you through your breastfeeding
          journey. We are a locally owned and operated business supporting all islands of Hawaii and specialize in
          various medical equipment, with a particular focus in women’s health.
        </p>
       
      </div>
    </section>
    <section class="bg-home2 bg-home2-mob ">
      <div class="container text-center text-black align-self-center">
        <h1 class="home-text4 bg-text-overlay" >Our Breast Pumps</h1>
        <router-link to="/breast_pumps">
        </router-link>
      </div>
    </section>
    <section class="ftco-section bg-light mb-5">

      <div class="container  text-center" >
        <img src="@/assets/site/images/icons/home_icon1.png" class="img-fluid home-icon" alt="">
        <h1 class="text-uppercase display-4">Breastfeeding is the gold<br> standard in infant feeding. </h1>

        <p class="i-font">
          Breastmilk provides immune support with amazing antibodies to give your baby everything they need and the
          best
          start for a healthy life. Breastmilk provides protection from many illnesses such as Diabetes, leukemias,
          infections and childhood obesity. Breastfeeding provides not only benefits to the child but the mother as
          well. Benefits for mom include decreased risk of ovarian and breast cancers, decreased blood loss following
          birth and a quicker return to prepregnacy weight.
        </p>
        <span><a href="https://www.aap.org/en-us/Pages/Default.aspx" class="text-black" target="_blanck"> -aap.org</a></span>
       
      </div>
      
    </section>
    <section class=" bg-light mb-5">
      <div class="container-fluid">
        <div class="row ">
          <div class="col-md-6 babyBg text-center mb-3">
            <h1 class="text-uppercase display-4 text-center home-sub4 home-text4" >Lactation<br> Education</h1>
            <router-link to="/lactation_edn" class="d-flex justify-content-center">
              <button type="button" 
                class="btn btn-light mt-3 col-4 home-btn11">More</button>
            </router-link>
          </div>
          <div class="col-md-6 motherBg text-center">
            <h1 class="text-uppercase display-4 text-center home-sub4 home-text4 "  >Lactation<br> Resources</h1>
            <router-link to="/lactation_res" class="d-flex justify-content-center">
              <button type="button" 
                class="btn btn-light mt-3  col-4  home-btn11">More</button>
            </router-link>
          </div>
        </div>
      </div>
    </section>  
    <div class="container text-center text-black align-self-center mb-15" >
      <h1 class="my-3 h1-sm">Book a breastfeeding class </h1>
      <p>This class covers everything breastfeeding, from getting off to a great start, pumping and back to work,
        nursing in the first hours and days through year(s) of life.
        This class is offered by Jodie Lactation Consultant.
        This is a great class for expectant parents to take to prepare for the most important part of caring for the
        newborn, Breastfeeding. Jodie provides evidence based information and has had years of experience working with
        birth and breastfeeding… More ></p>
      <router-link to="/lactation_edn"> <button type="button" class="btn btn-light mt-3 col-md-3">book</button>
      </router-link>

    </div>
    
   
    
  </div>
</template>

<script>
    import Product from '@/views/site/Product'
    import ProductApply from '@/views/site/ProductApply'
    export default {
        name: "HomeView",
        components: {
            Product,
            ProductApply
        },
        data() {
            return {
                collections: [],
                accessories: [],
                selectedProduct: [],
                loader: false,
                logout: "",
            };
        },
        created() {
          let parameters = this.$route.query
          console.log(parameters)
          this.logout = this.$route.query.redirect
          if(this.logout == "logout"){
            localStorage.clear();
            window.location.href = "/";
          }
            this.getHomeProducts();
        },
        methods: {
            getHomeProducts() {
                this.loader = true;
                var method_type = "GET";
                var fetch_url = process.env.VUE_APP_URL + "api/getProductHomepage";
                fetch(fetch_url, {
                        method: method_type,
                        headers: {
                            "content-type": "application/json",
                            "X-Requested-With": "XMLHttpRequest",
                            // Authorization: "Bearer " + $('meta[name="api_token"]').attr("content")
                        },
                    })
                    .then(res => res.json())
                    .then(data => {
                        if (data != null) {
                            this.collections = data.collections;
                            this.accessories = data.accessories;
                        }
                        this.loader = false;
                    })
            },
            showOrderModal(productEmited) {
                this.selectedProduct = productEmited;
                this.$bvModal.show('productapply-modal')
            },
            hideTopbar() {},
        }
    };
</script>